import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faXmarkCircle, faEdit } from '@fortawesome/free-solid-svg-icons'
import theme from '../../../../core/utils/theme'
import { Tooltip, Button, theme as antdTheme } from 'antd'
import { FilterFilled } from '@ant-design/icons'
import ServicesEnums from './enums'

const ServicesTemplate = {
  dataModel: {
    isActive: {
      label: 'Status:',
      key: 'isActive',
      required: false
    },
    name: {
      label: 'Provide a service name:',
      key: 'name',
      required: true,
      placeholder: 'e.g. Doctor Consultation',
      validationMsg: 'Please provide the service`s name'
    },
    type: {
      label: 'Specify the service type:',
      key: 'type',
      required: true,
      options: [
        {
          label: ServicesEnums.labels.STANDARD_CONSULT,
          value: ServicesEnums.labels.STANDARD_CONSULT
        },
        {
          label: ServicesEnums.labels.VITALITY_HEALTH_CHECK,
          value: ServicesEnums.labels.VITALITY_HEALTH_CHECK
        }
      ],
      validationMsg: 'Please specify the service type',
      placeholder: '- Select a service type -'
    },
    rate: {
      label: 'Provide the service cost:',
      key: 'rate',
      required: true,
      placeholder: 'e.g. 450',
      validationMsg: 'Please provide the service cost'
    },
    timeslotInterval: {
      label: 'Provide the consultation duration:',
      key: 'timeslotInterval',
      required: true,
      placeholder: 'e.g. 15',
      validationMsg: 'Please provide the consultation duration'
    },
    screeningTemplate: {
      key: 'screeningTemplate',
      required: false
    }
  },

  dataTemplate: () => {
    return {
      isActive: true,
      rate: null,
      name: null,
      type: null,
      timeslotInterval: null
    }
  },

  columnTemplate: (filters, editRecord) => {
    const { token } = antdTheme.useToken()

    return [
      {
        title: '',
        key: 'action',
        width: '50px',
        align: 'center',
        render: (_, record) => (
          <Tooltip title='Edit service details'>
            <Button
              type='primary'
              size='small'
              onClick={(e) => {
                e.stopPropagation() // Prevent row click event
                if (typeof editRecord === 'function') {
                  editRecord(record)
                }
              }}
              icon={<FontAwesomeIcon icon={faEdit} />}
              style={{
                height: '32px',
                width: '32px',
                minWidth: '32px',
                background: token.actionColor,
                borderRadius: '50%',
                boxShadow: `0 2px 4px ${token.colorPrimaryBg}`,
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0
              }}
            />
          </Tooltip>
        )
      },
      {
        title: 'Service Name',
        dataIndex: 'name',
        key: 'name',
        render: (text) => <span style={{ fontWeight: 600, color: '#1f1f1f' }}>{text}</span>
      },
      {
        title: 'Rate (ZAR)',
        dataIndex: 'rate',
        key: 'rate',
        render: (value) => (
          <span
            style={{
              padding: '3px 10px',
              borderRadius: '12px',
              backgroundColor: `${token.actionColor}10`,
              fontSize: '0.9rem',
              fontWeight: 500,
              display: 'inline-block'
            }}
          >
            {value}
          </span>
        )
      },
      {
        title: 'Timeslot Interval (Minutes)',
        dataIndex: 'timeslotInterval',
        key: 'timeslotInterval',
        render: (value) => (
          <span
            style={{
              padding: '3px 10px',
              borderRadius: '12px',
              backgroundColor: `${token.actionColor}10`,
              fontSize: '0.9rem',
              fontWeight: 500,
              display: 'inline-block'
            }}
          >
            {value}
          </span>
        )
      },
      {
        title: 'Status',
        dataIndex: 'isActive',
        key: 'isActive',
        render: (status) => {
          if (status === true)
            return (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Tooltip title='Active'>
                  <span
                    className='service-icon'
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      backgroundColor: `${token.colorSuccess}15`,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }}
                  >
                    <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: 16, color: token.colorSuccess }} />
                  </span>
                </Tooltip>
              </div>
            )
          else
            return (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Tooltip title='Deactivated'>
                  <span
                    className='service-icon'
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      backgroundColor: `${token.colorError}15`,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }}
                  >
                    <FontAwesomeIcon icon={faXmarkCircle} style={{ fontSize: 16, color: token.colorError }} />
                  </span>
                </Tooltip>
              </div>
            )
        },
        filterMultiple: false,
        filters: [
          {
            text: 'Active',
            value: true
          },
          {
            text: 'Inactive',
            value: false
          }
        ],
        onFilter: (value, record) => {
          return record.isActive === value
        },
        filterIcon: (filtered) => (
          <Tooltip title='Filter by Status'>
            <FilterFilled style={{ color: filtered ? token.actionColor : undefined }} />
          </Tooltip>
        )
      }
    ]
  }
}

export default ServicesTemplate
